/** Referral Recruiting Award 2026 エントリー関連の日時（日本時間） */

/** LPのエントリー導線を表示し始める時刻 */
export const AWARD_ENTRY_CTA_VISIBLE_FROM = new Date("2026-10-09T10:00:00+09:00");

/** エントリー受付終了時刻 */
export const AWARD_ENTRY_CLOSED_AT = new Date("2026-12-31T17:00:00+09:00");

/** setTimeout が扱える最大遅延（約24.8日）。これを超えると即発火するためガードする */
export const AWARD_ENTRY_MAX_TIMEOUT_MS = 2_147_483_647;

export const isAwardEntryClosed = (now: Date = new Date()) =>
  now.getTime() >= AWARD_ENTRY_CLOSED_AT.getTime();

export const isAwardEntryCtaVisible = (now: Date = new Date()) => {
  const t = now.getTime();
  return t >= AWARD_ENTRY_CTA_VISIBLE_FROM.getTime() && t < AWARD_ENTRY_CLOSED_AT.getTime();
};
